import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon } from '@breezeway/brzw-components';

const CustomInputWithStyleguide = ({ onClick, value, label, error, required }) => (
  <div
    className={classnames('datepicker-custom-button', {
      '-error': error,
      '-is-required': required,
    })}
    onClick={onClick}
    role="button"
    tabIndex={0}
  >
    <div className="datepicker-custom-button-wrapper">
      <span className="datepicker-custom-button-label">{label}</span>
      <span
        className={classnames('datepicker-custom-button-value', {
          '-placeholder': !value,
        })}
      >
        {value || 'Select a due date'}
      </span>
    </div>
    <Icon className="datepicker-custom-button-icon" iconName="chevron-down" />
  </div>
);

CustomInputWithStyleguide.propTypes = {
  error: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
  required: PropTypes.bool,
  value: PropTypes.string,
};

export default CustomInputWithStyleguide;
